import { render, staticRenderFns } from "./ShopBlockCloud.vue?vue&type=template&id=4abed61d&scoped=true"
import script from "./ShopBlockCloud.vue?vue&type=script&lang=js"
export * from "./ShopBlockCloud.vue?vue&type=script&lang=js"
import style0 from "./ShopBlockCloud.vue?vue&type=style&index=0&id=4abed61d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abed61d",
  null
  
)

export default component.exports